export default __webpack_public_path__ + "static/media/no-content.500eab46.svg";